import fetch from '../../utils/fetch';

export function error(error) {
    return { type: 'SONG_AVAILABLE_ERROR', error };
}

export function loading(loading) {
    return { type: 'SONG_AVAILABLE_LOADING', loading };
}

export function success(data) {
    return { type: 'SONG_AVAILABLE_SUCCESS', data };
}

export function picked(data) {
    return { type: 'SONG_AVAILABLE_PICKED', data };
}

export function list(page = '/songs/available') {
    return dispatch => {
        dispatch(loading(true));
        dispatch(error(''));

        fetch(page)
            .then(response => response.json())
            .then(data => {
                dispatch(loading(false));
                dispatch(success(data));
            })
            .catch(e => {
                dispatch(loading(false));
                dispatch(error(e.message));
            });
    };
}

export function pick(songId) {
    return dispatch => {
        dispatch(loading(true));
        dispatch(error(''));

        const request = fetch('/songs/' + songId + '/pick', {
            method: 'PUT'
        })
            .then(response => response.json())
            .then(data => {
                dispatch(loading(false));
                dispatch(picked(data));
            })
            .catch(e => {
                dispatch(loading(false));
                dispatch(error(e.message));
            });

        return request;
    };
}

export function reset() {
    return { type: 'SONG_AVAILABLE_RESET' };
}



// WEBPACK FOOTER //
// ./src/actions/song/available.js